module.exports = __webpack_public_path__ + "a4b4ab67edf7bd32d45c24221ac42722.svg";